import { ReactNode, useMemo, useState } from 'react';
import RegulationMyListDataContext from '@raas/shared/src/features/regulation/contexts/RegulationMyListDataContext';

import type { RegulationMyListDataContextContract } from '@raas/shared/src/features/regulation/contexts/RegulationMyListDataContext';
import type {
  RegulationContract,
  RegulationHistoryContract,
} from '@raas/shared/src/features/regulation/contracts/regulation.type';
import type { PaginationParamsContract } from '@raas/shared/src/features/pagination';

type RegulationMyListContextProviderProps = {
  children: ReactNode;
};

export function RegulationMyListContextProvider({
  children,
}: RegulationMyListContextProviderProps) {
  const [myRegulations, setMyRegulations] = useState<RegulationContract[]>([]);
  const [nextCursor, setNextCursor] = useState<string | null>(null);
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [paginationParams, setPaginationParams] = useState<PaginationParamsContract>({});
  const [isMyListLoading, setIsMyListLoading] = useState<boolean>(false);
  const [myRegulationHistory, setMyRegulationHistory] = useState<RegulationHistoryContract[]>([]);
  const [isHistoryListLoading, setIsHistoryListLoading] = useState<boolean>(false);

  const dataValue: RegulationMyListDataContextContract = useMemo(
    () => ({
      myRegulations,
      setMyRegulations,
      nextCursor,
      setNextCursor,
      hasMore,
      setHasMore,
      paginationParams,
      setPaginationParams,
      isMyListLoading,
      setIsMyListLoading,
      myRegulationHistory,
      setMyRegulationHistory,
      isHistoryListLoading,
      setIsHistoryListLoading,
    }),
    [
      myRegulations,
      nextCursor,
      hasMore,
      paginationParams,
      isMyListLoading,
      myRegulationHistory,
      isHistoryListLoading,
    ]
  );
  return (
    <RegulationMyListDataContext.Provider value={dataValue}>
      {children}
    </RegulationMyListDataContext.Provider>
  );
}
